/**
 * Product Form Validators
 */
import { z } from 'zod';

export const productSchema = z.object({
  name: z.string().min(1, 'Nome é obrigatório').max(100, 'Nome muito longo'),
  description: z.string().max(500, 'Descrição muito longa').optional(),
  price: z.number().min(0, 'Preço não pode ser negativo'),
  cost_price: z.number().min(0, 'Preço de custo não pode ser negativo').optional(),
  category_id: z.string().min(1, 'Categoria é obrigatória'),
  stock: z.number().int().min(0, 'Estoque não pode ser negativo').optional(),
  min_stock: z.number().int().min(0, 'Estoque mínimo não pode ser negativo').optional(),
  max_stock: z.number().int().min(0, 'Estoque máximo não pode ser negativo').optional(),
  sku: z.string().max(50, 'SKU muito longo').optional().nullable(),
  barcode: z.string().max(50, 'Código de barras muito longo').optional().nullable(),
  is_service: z.boolean().optional(),
  track_stock: z.boolean().optional(),
  is_active: z.boolean().optional(),
  supplier_id: z.string().optional().nullable(),
  brand_id: z.string().optional().nullable(),
  unit_of_measure_id: z.string().optional().nullable(),
  min_stock_alert: z.boolean().optional(),
  min_stock_quantity: z.number().int().min(0).optional(),
  variations: z.array(z.object({
    id: z.string().optional(),
    name: z.string().min(1, 'Nome da variação é obrigatório'),
    price_modifier: z.number(),
    sku: z.string().optional().nullable(),
    is_active: z.boolean().optional(),
  })).optional(),
});

export const productVariationSchema = z.object({
  name: z.string().min(1, 'Nome da variação é obrigatório'),
  price_modifier: z.number(),
});

export type ProductFormData = z.infer<typeof productSchema>;
